import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, NgZone, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild, ViewChildren } from '@angular/core';
import { CompilationModel, EPackingStatus, IPalletRef, PackingConditionItem, PackingConditions } from '../../../../@models/erp/compilation';
import { CompilationTypeData, PalettType, PalletType, UnitData } from '../../../../@models/erp/compilationData';
import { IDropdownOptions, SharedDataService } from '../../../../@core/service/shared-data.service';
import { TreeService } from '../../../../@core/service/tree.service';
import { NbDialogService, NbPopoverDirective } from '@nebular/theme';
import { Subscription } from 'rxjs';
import { EventService } from '../../../../@core/service/eventService';
import { ApiService } from '../../../../@core/service/api.service';
import { EBoxStatus, SpoBoxModel } from '../../../../@models/erp/spoBox';
import { mongoId, nrkPad } from '../../../../@core/common/global';
import { IPackingWizardData } from './packing-wizard/packing-wizard.component';
import { LineItemModel } from '../../../../@models/erp/lineItem';
import { DocMetrics } from '../line-item-container/line-item-metrics/line-item-metrics.component';
import { RoundPipe } from '../../../../@theme/pipes';
import * as uniqid from 'uniqid';
import { EBoxLabelPriority, EProductType } from '../../../../@models/erp/finishedProduct';
import { PopupDocumentComponent } from '../document-printer/popup-document/popup-document.component';
import { AuthGuardService } from '../../../../@core/service/auth-guard.service';
import { CommonDialogComponent, NrkDialogType } from '../../shared/common-dialog/common-dialog.component';
import * as moment from 'moment';
import { Changelog } from '../../shared/changelog/changelog.component';
import { id } from 'date-fns/locale';

@Component({
  selector: 'ngx-packing-conditions',
  templateUrl: './packing-conditions.component.html',
  styleUrls: ['./packing-conditions.component.scss'],
})
export class PackingConditionsComponent implements OnInit, OnChanges, OnDestroy {
  @Input() compilation: CompilationModel;
  @Input() grossWeight: number; // why override? can be calced
  @Input() disabled: boolean = false;
  @Input() print: boolean = false;
  @Input() highlight: PackingConditions;
  @Input() coversheet = false;
  @Input() lineItemIdx = undefined;
  @Input() legacy = false;
  @Input() tcSpoMap: any = [];
  @Input() warehousing = false;
  @Input() useOldPacking = false;
  @Output() grossWeightChange = new EventEmitter<number>()

  @ViewChild('packingTable', { static: false }) packingTable!: ElementRef;
  @ViewChildren(NbPopoverDirective) lotPopover: NbPopoverDirective[];
  @ViewChildren(NbPopoverDirective) boxesPopover: NbPopoverDirective[];

  packingStatus = EPackingStatus;
  productType = EProductType;
  typeData = CompilationTypeData;
  // palletType = PalletType;
  // palletTypeOptions = PalletType.getOptions();
  palletReferences: IPalletRef[];
  palRefOptions: { id: string, name: string }[];
  // typeOfCartonBox = TypeOfCartonBox;
  // typeOfCartonBoxOptions = TypeOfCartonBox.getOptions();

  packingStore: any = null;
  packingTypeOptions: IDropdownOptions[][] = [];

  // public multiPalletColors = [ 'cornflowerblue', 'mediumseagreen', 'orange' ];
  spoBoxes: SpoBoxModel[];

  productionLotTable: any = {};
  palletSummary = []; // legacy: currently unfunctional; DON'T DELETE maybe used some time again
  palletInfo: { [palletId: string]: any };

  totalNetWeight = 0;
  totalGrossWeight = 0;
  netWeightPerPos = Array.from({ length: 100 }, () => 0);
  grossWeightPerPos = Array.from({ length: 100 }, () => 0);

  packingForIdx: { [idx: number]: { [pidx: number]: any } } = []; 

  currentDm = [];
  
  spoCustomerRefMismatch = [];

  ocCompilation: CompilationModel;

  private uid = uniqid();

  // tcSpoMap: any = [];

  // palletIdx: number;
  // palletSum: number;

  constructor(
    private cdRef: ChangeDetectorRef,
    private ngZone: NgZone,
    private auth: AuthGuardService,
    protected data: SharedDataService,
    private tree: TreeService,
    private event: EventService,
    private api: ApiService,
  ) { }

  subscriptions: Subscription[] = [];

  async ngOnInit() {

    if (!this.compilation.packingConditions) {
      this.compilation.packingConditions = [];
    }
  
    if (!this.grossWeight) this.grossWeight = this.compilation.packingConditions.reduce((a, c) => a + c.weight, 0);

    this.compilation.lineItems.forEach((li, idx) => {
      this.currentDm[idx] = new DocMetrics(this.api, this.compilation, li, new RoundPipe(), this.data, true);
    })

    // if (this.highlight) {
    //   this.compilation.packingConditions.forEach((pc, idx) => {
    //     if (pc.palNr === this.highlight.palNr) this.palletIdx = idx + 1;
    //   })
    //   this.palletSum = this.compilation.packingConditions.length;
    // }
    await this.data.loadCompilationData();
    this.packingStore = this.data.compilationData.packingStore;

    if (this.warehousing) {
      this.subscriptions.push(this.tree.documentTreeLoadedEvent.subscribe(async () => {
        this.ocCompilation = await this.api.loadCompilationByCode(this.tree.linkedOC.code);
      } ))
    }

    // console.log('ngOnInit initProductiontable');
    // this.initProductionTable()

    this.data.loadPalletRefs().then(() => this.refreshPalletReferences())

    // this.data.loadSpoBoxes().then(() => this.initProductionTable());

    // this.subscriptions.push(this.event.reloadBoxes.subscribe(() => this.initProductionTable() ))

    this.data.packingComponent = this;

    this.subscriptions.push(this.event.recalcPacking.subscribe(compilation => {
      this.palletInfo = this.getPalletInfo();
      this.recalc();
      // this.palletSummary = this.getPalletSummary();
    }));

    // console.log('warehousing', this.warehousing);
  }


  private static cache = {}
  private static boxcache = {}
  async initProductionTable() {
    this.productionLotTable = [];
    this.spoBoxes = [];
    // this.data.boxesAreLoading.push(true);
    this.data.boxesAreLoading(true);
    let lidx = 0;
    for (const li of this.compilation.lineItems) {
      this.spoCustomerRefMismatch[lidx] = [];

      // console.log('line item product', li.finishedProduct);
      // console.log('li pfspo', li.pfspo);

      if (Array.isArray(li.pfspo)) for (const assocSpo of li.pfspo) {
        // console.time('initprodtable spo ' + this.uid);
        // let spo = PackingConditionsComponent.cache[assocSpo.code];
        // if (!spo) {
        //   spo = await this.api.loadCompilationByCode(assocSpo.code);
        //   PackingConditionsComponent.cache[assocSpo.code] = spo
        // }
        // console.timeEnd('initprodtable spo ' + this.uid);
        // const docLineItem = assocSpo.internalPos ? spo.lineItems.find(f => f.position?.internalPos === assocSpo.internalPos) : spo.lineItems.find((f, idx) => idx === assocSpo.pos-1);
        // console.log('initprodtable', spo.code, assocSpo.code, this.uid, assocSpo.internalPos, docLineItem, spo, assocSpo);
        // console.time('initprodtable boxes ' + this.uid);
        // let boxes = PackingConditionsComponent.boxcache[spo.code];
        // if (!boxes) {
        //   boxes = await this.api.loadSpoBoxes({ spo: spo.code, status: { $gt: 0 } });
        //   PackingConditionsComponent.boxcache[spo.code]
        // }
        // console.timeEnd('initprodtable boxes ' + this.uid);
        const spo = await this.api.loadCompilationByCode(assocSpo.code);
        if (!spo) continue; // TODO: shouldn't happen
        const docLineItem = assocSpo.internalPos ? spo.lineItems.find(f => f.position?.internalPos === assocSpo.internalPos) : spo.lineItems.find((f, idx) => idx === assocSpo.pos-1);
        const boxes = await this.api.loadSpoBoxes({ spo: spo.code, status: { $gt: 0 } });
        // const boxes = this.data.spoBoxes.filter(f => f.spo === spo.code && f.status > EBoxStatus.free);
        // console.log('initProductionTable', this.compilation.code, assocSpo.pos, spo.lineItems.map(m => m.position.internalPos), boxes, spo, docLineItem);

        // console.log('recipient match', mongoId(this.compilation.recipient), spo?.recipient, li.pfspo?.map(m => mongoId(m.doc?.recipient)))


        if (docLineItem) {

          if (mongoId(spo?.customerReference) !== mongoId(this.compilation.recipient) && !this.spoCustomerRefMismatch[lidx].find(f => mongoId(f) === mongoId(spo?.customerReference))) {
            this.spoCustomerRefMismatch[lidx].push(mongoId(spo?.customerReference));
          }

          boxes?.forEach(box => {
            this.spoBoxes[box.boxId] = box;
            this.productionLotTable?.push({
              boxId: box.boxId,
              status: box.status,
              spo: spo.code,
              pos: assocSpo.pos,
              case: box.case,
              lot: docLineItem.boxDetails?.filter(f => f.case === box.case)?.map(m => m.lot),
              tc: docLineItem?.boxDetails?.filter(f => f.case === box.case)?.map(m => m.tc),
              quantity: box.quantity,
              weight: box.weight,
              boxType: docLineItem?.boxDetails?.filter(f => f.case === box.case)[0]?.boxType,
              palletId: box.palletRef,
            })
            // console.log('spo filter', box.boxId, docLineItem?.boxDetails?.filter(f => f.case === box.case)[0]?.boxType, docLineItem?.boxDetails?.filter(f => f.case === box.case), docLineItem?.boxDetails?.filter(f => +f.case === +box.case))
          })
        }
      }

      lidx++;

      // console.log('spoCustomerRefMismatch', this.spoCustomerRefMismatch);

    }
    // console.log('production lot table', this.productionLotTable, this.spoBoxes);
    // console.log('production lot table', this.productionLotTable, this.packingForIdx);

    const fp = this.data.getPackingConfig()?.finalPacking;

    const defaultOpts = [
      fp.find(f => f.pallet === 'P0'), 
    ].map(m => ({ id: m.id, name: m.name }))

    this.packingTypeOptions = []
    this.packingTypeOptions['default'] = defaultOpts;
    this.data.getPackingConfig()?.boxDetails?.forEach(el => {
      // console.log('packing', el);
      // const items = fp.filter(f => f.cartonBox === el.id).map(m => ({ id: m.id, name: m.name }))
      // this.compilation.lineItems.forEach((li, idx) => {
      //   this.packingTypeOptions[el.id] = [];
      //   const productDefaultOpts = li.finishedProduct.packingSpec.flatMap(ps => {
      //     const packing = fp.find(f => f.id === ps);
      //     return ({ id: packing.id, name: packing.name });
      //   })
      //   this.packingTypeOptions[el.id][idx] = [...productDefaultOpts, ...defaultOpts, ...items];
      // })
      const items = fp.filter(f => f.cartonBox === el.id).map(m => ({ id: m.id, name: m.name }))
      this.packingTypeOptions[el.id] = [...defaultOpts, ...items];
    })

    // this.data.boxesAreLoading.pop();
    this.data.boxesAreLoading();

    this.compilation.packingConditions.forEach(async (pc, idx) => {
      // this.shelfLifeError[pc.palId] = await this.data.checkShelfLife(this.compilation, pc, this.spoBoxes);
      this.shelfLifeError[pc.palId] = await this.api.checkShelfLife(mongoId(this.compilation), pc.palId);
    })

    // console.log('shelf life error', this.spoBoxes, this.shelfLifeError);


    this.cdRef.detectChanges();

  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  isDisabled() {
    if (this.compilation.packingStatus >= EPackingStatus.readyForDispatch) return true;
    return this.disabled;
  }

  originalPacking: PackingConditions[] = [];
  shelfLifeError: boolean[] = [];
  async ngOnChanges(changes: SimpleChanges): Promise<void> {

    // console.log('ngOnChanges', changes, this.compilation, this.disabled, this.useOldPacking);

    if (changes.legacy?.isFirstChange() && this.compilation.packingConditions) {
      this.originalPacking = JSON.parse(JSON.stringify(this.compilation.packingConditions));
    }

    if (changes.useOldPacking?.currentValue) {
      this.compilation.packingConditions.forEach(async (pc, idx) => {
        pc.dimensions = this.originalPacking[idx].dimensions;
      })
    }
        
    if (this.compilation.type !== CompilationTypeData.get('OC').id && !this.warehousing) this.disabled = true;
    if (this.compilation.type !== CompilationTypeData.get('OC').id && !this.warehousing) this.disabled = true;

    if (changes.compilation && changes.compilation.currentValue && this.compilation.packingConditions) {
      this.compilation.packingConditions = this.compilation.packingConditions.filter(pc => pc !== null);

      this.compilation.lineItems.forEach((li, lidx) => {
        this.packingForIdx[lidx] = [];
        this.getPackingFor(lidx)?.forEach((pal, pidx) => {
          this.packingForIdx[lidx][pidx] = pal?.items[0]?.typeOfBox;
        })
      })

      // this.palRefOptions = this.data.latestVersionItems.filter(f => f.type === CompilationTypeData.get('DN').id)?.reduce((a, c) => {
      //   const test = [...a, ...(c?.packingConditions?.map(p => ({ id: c.code + '-' + p.palNr, name: c.code + '-' + p.palNr})) || [])]
      //   console.log('code:', c.code, test, c.packingConditions?.map(o => o.palNr), c.packingConditions, c);
      //   return test;
      // }, [])
      // console.log('packing', this.palRefOptions, this.data.latestVersionItems.filter(f => f.type === CompilationTypeData.get('DN').id))
      // console.log('packing, ngOnChanes', changes)
      // console.log('ngOnChanges initProductionTable')
      await this.initProductionTable();
      // this.refreshPalletReferences();
      // console.log('ngOnChanges (packingConditions)', changes, changes.compilation.currentValue, changes.compilation.previousValue);
      // if (changes.compilation.currentValue !== changes.compilation.previousValue) {
      //   this.tcSpoMap = await this.getTcSpoMap()
      // }
      // console.log('initProductionTable');
      this.recalc();
    }
  }

  async refreshPalletReferences() {
    // await this.api.getPalletReferences().then((refs) => {
    //   this.palletReferences = refs;
    //   console.log('pallet refs', this.palletReferences)
    //   this.palRefOptions = refs.map(m => ({ id: m.palId, name: `${m.code} - ${m.palId} - Pos ${m.pos+1} (${m.el+1}/${m.of})` }) )
    //   this.palletSummary = this.getPalletSummary();
    // });
    this.palletReferences = this.data.palletRefs;
    this.palRefOptions = this.palletReferences.map(m => ({ id: m.palId, name: `${m.code} - ${m.palId} - Pos ${m.pos+1} (${m.el+1}/${m.of})` }) )
    // this.palletSummary = this.getPalletSummary();
    this.palletInfo = this.getPalletInfo();
    // console.log('refreshPalletReferences', this.palletReferences);
    this.recalc()
  }

  private getPackingFor(idx: number): PackingConditions[] {
    if (this.compilation?.packingConditions?.find(f => f.lineItemIdx === undefined)) {
      return [];
      // throw new Error('lineItemIdx is undefined');
    }
    return this.compilation?.packingConditions?.filter(f => f.lineItemIdx === idx);
  }

  getPos(pallet: PackingConditions) {
    return this.compilation?.packingConditions?.findIndex(f => f === pallet) + 1;
  }

  getUnitQuantity(lidx: number, row: any) {
    const pieces = row.quantity;
    const lineItem = this.compilation.lineItems[lidx];
    const unit = lineItem?.displayUnit;
    const quantity = this.currentDm[lidx]?.metrics?.convert(+pieces, 1, unit);
    // row['unitQuantity'] = quantity;
    return `${quantity} ${UnitData.get(unit)?.short}`;
  }

  // getLiPos(pallet: PackingConditions) {
  //   pallet.
  // }

  async addPallet(lineItemIdx: number, manual = false) {
    
    const packingConditions = new PackingConditions();
    packingConditions.lineItemIdx = lineItemIdx;
    packingConditions.packingType = manual ? 'manual' : 'FPD1';
    // // TODO: remove legacy
    // packingConditions.palNr = 'P' + (this.compilation.packingConditions.reduce((a, c) => //legacy
    //   Math.max(a, +(c?.palNr || '').replace(/[a-zA-Z]?/,'')), 0) + 1 //legacy
    // ).toString().padStart(3, '0') //legacy
    packingConditions.palId = await this.api.increaseCounter('pallet');
    packingConditions.items = [];
    this.compilation.packingConditions.push(packingConditions);
    this.compilation.packingConditions = this.compilation.packingConditions.sort((a,b) => a.lineItemIdx === b.lineItemIdx ? 0 : (a.lineItemIdx > b.lineItemIdx ? 1 : -1))
    this.palletInfo = this.getPalletInfo();
    return packingConditions;
  }

  protected isSaving = false;
  async removePallet(pallet: PackingConditions) {
    this.isSaving = true
    // console.log('this.spoboxes pre', this.spoBoxes);
    const idx = this.compilation.packingConditions.findIndex(f => f === pallet)
    const remove = this.compilation.packingConditions.splice(idx, 1);
    // if (remove[0].items) await this.setBoxStatus(remove[0].items?.map(m => m.boxes).flat(), EBoxStatus.assignedSpo);
    const boxIds = remove[0].items?.map(m => m.boxes).flat();
    const boxes = boxIds.map(m => this.spoBoxes[m]).filter(notNull => notNull);
    boxes.forEach(box => {
      box.palletRef = null;
      box.status = box.docRef ? EBoxStatus.assignedSpo : EBoxStatus.free;
      this.spoBoxes[box.boxId] = box;
    })
    // console.log('boxes - remove pallet', this.spoBoxes, boxes);
    await this.api.saveSpoBoxes(boxes);
    await this.saveCompilation();
    this.isSaving = false;
  }

  async removePallets() {
    while (this.compilation.packingConditions?.length) {
      await this.removePallet(this.compilation.packingConditions[0]);
    }
  }

  async generateNewPalletId() {
    return await this.api.increaseCounter('pallet');
  }

  addItem(pallet: PackingConditions): PackingConditionItem {
    const item = new PackingConditionItem();
    pallet.items?.push(item);
    return item;
  }

  async removeItem(pallet: PackingConditions, idx: number) {
    const remove = pallet.items?.splice(idx, 1);
    await this.setBoxStatus(remove[0]?.boxes, EBoxStatus.assignedSpo)
    if (!pallet.items?.length) this.removePallet(pallet);
    await this.saveCompilation();
  }

  async setBoxStatus(boxIds: number[], status: EBoxStatus) {
    // console.log('setBoxStatus', boxIds, status);

    if (this.compilation.useOldPackingConditions) return;

    const boxes = boxIds.map(m => this.spoBoxes[m]);
    // console.log('============>boxes pre', boxes);
    // const filterStatus = status === EBoxStatus.assignedSpo ? EBoxStatus.assignedPallet : EBoxStatus.assignedSpo;
    boxes.forEach(box => {
      // // if (box?.status === filterStatus || forced) {
      //   box.status = status;
      // // }
      // if (box.status === EBoxStatus.free) {
      //   box.docRef = box.docRefPos = box.docRefProduct = null;
      // }
      // // console.log('====> pallet ref1', box.palletRef, box.status);
      // if (box.status < EBoxStatus.assignedPallet) box.palletRef = null;
      // // console.log('====> pallet ref2', box.palletRef, box.status);

      box.status = status;
      if (!box.docRef) {
        box.status === EBoxStatus.free;
      } else if (box.status === EBoxStatus.free) {
        box.docRef = box.docRefPos = box.docRefProduct = null;
      }
      if (box.status < EBoxStatus.assignedPallet) box.palletRef = null;
    })
    // console.log('===>boxes post', boxes);
    await this.api.saveSpoBoxes(boxes);
  }

  recalc() {

    if (this.compilation.useOldPackingConditions || !this.data.compilationData?.packingStore) return;
    
    // console.time('recalc packing...');

    const palletDetails = this.data.getPackingConfig().palletDetails;
    const boxDetails = this.data.getPackingConfig().boxDetails;
    const finalPacking = this.data.getPackingConfig().finalPacking;

    // console.log(this.packingStore, palletDetails, boxDetails, finalPacking);

    this.compilation.packingConditions.forEach(pallet => {

      // calc collie dimensions
      // const palletRow = palletDetails?.find(f => f.id === pallet.palletType);
      // const cartonBox = pallet.items[0]?.typeOfBox;
      // const cartonRow = boxDetails.find(f => f.id === cartonBox);
      // // const layerRow = boxLayer.find(f => f.pallet === palletRow?.name && f?.cartonBox === cartonBox);
      // const finalPackingRow = finalPacking.find(f => f.pallet === palletRow?.id && f?.cartonBox === cartonBox);

      // console.log('packingConditions', pallet.palId, pallet.packingType, pallet.palletType, pallet.items[0]?.typeOfBox);

      // const parent = this.getPalData(pallet)
      // const ref = this.compilation.packingConditions?.find(f => f.palId === parent.palId)
      // console.log('packingConditions2', parent, this.getPalRef(pallet), ref, this.compilation.packingConditions?.find(f => f.palId === parent.refPalId));
      // if (parent && ref) {
      //   pallet.packingType = ref.packingType;
      //   pallet.palletType = ref.palletType;
      //   pallet.items[0].typeOfBox = ref.items[0].typeOfBox;
      // }
      if (!pallet.items) return;

      const finalPackingRow = this.data.getPackingConfig(pallet.packingType);
      const palletRow = this.data.getPackingConfig(pallet.palletType);
      const cartonRow = this.data.getPackingConfig(pallet.items[0]?.typeOfBox);

      // console.log('recalc', pallet.packingType, pallet.palletType, pallet.items[0]?.typeOfBox)
      // console.log('calc collie dimensions', pallet.palId, palletRow, cartonRow, finalPackingRow)

      const numberOfBoxes = +pallet.items?.reduce((a, c) => a + c.numberOfBoxes, 0);
      const boxesPerLayer = +finalPackingRow?.boxesPerLayer// +layerRow?.boxesPerLayer;
      const boxHeight = +cartonRow?.height;
      const multiplier = ((+finalPackingRow?.multiplier || 0) + 100) / 100;

      if (!this.compilation.useOldPackingConditions) {
        let calcHeight = Math.round(+palletRow?.height + Math.ceil(numberOfBoxes / boxesPerLayer) *  boxHeight) + (+finalPackingRow?.heightAdjustment || 0);
        pallet.dimensions = !palletRow?.length || !palletRow?.width ? '' : `${palletRow?.length}x${palletRow?.width}`;
        if (pallet.dimensions && !isNaN(calcHeight)) pallet.dimensions += `x${pallet.heightOverride || calcHeight}`;
      }

      // console.log('calc(2)', numberOfBoxes, boxesPerLayer, boxHeight, multiplier, calcHeight, pallet.dimensions, finalPackingRow?.heightAdjustment, finalPackingRow.temperatureStickerWeight), (+finalPackingRow.thermoShieldWeight), (+finalPackingRow.edgeProtectionWeight);

      // calc net / gross weight
      if (this.spoBoxes?.length) {
        const netWeight = pallet?.items?.reduce((a, c) => {
          const boxes: SpoBoxModel[] = this.spoBoxes && c.boxes?.map(m => this.spoBoxes[m]) //?.reduce((a, c) => a + c?.weight), 0);
          const weight = boxes?.reduce((a, c) => a + (c?.weight || 0), 0);
          // console.log('pal boxes weights', boxes.map(m => `${m.boxId} ${m.weight}`), weight);
          return a + weight;
        }, 0);
        // console.log('--> pal net weight', netWeight, pallet.items);
        if (!pallet.netWeight) {
          pallet.netWeight = netWeight;
        }
        if (!pallet.weight) {
          pallet.weight = netWeight * multiplier  + numberOfBoxes*(+cartonRow?.weight) + (+palletRow?.weight || 0) 
            + (+finalPackingRow?.temperatureStickerWeight || 0) + (+finalPackingRow?.thermoShieldWeight || 0) + (+finalPackingRow?.edgeProtectionWeight || 0);
        }
      }
      // console.log('pal calc(3)', pallet.weightOverride, pallet.weight, pallet.netWeight * multiplier  + numberOfBoxes*(+cartonRow?.weight) + (+palletRow?.weight || 0), (+finalPackingRow?.heightAdjustment), (+finalPackingRow.thermoShieldWeight), (+finalPackingRow.thermoShieldWeight), (+finalPacking.edgeProtectionWeight))
      console.log('pal calc(3)', pallet.weightOverride, pallet.weight, pallet.netWeight, multiplier, numberOfBoxes, (+cartonRow?.weight), (+palletRow?.weight || 0), (+finalPackingRow?.heightAdjustment), (+finalPackingRow.thermoShieldWeight), (+finalPackingRow.thermoShieldWeight), (+finalPacking.edgeProtectionWeight))

      // console.log(pallet);
    })

    // this.compilation.lineItems[this.lineItemIdx]?.pfspo.forEach(spo =>
    //   console.log('=-=-=->box details', spo.docLineItem?.boxDetails)
    // ) 

    // if (this.spoBoxes?.length) this.palletSummary = this.getPalletSummary();
    if (this.spoBoxes?.length) this.palletInfo = this.getPalletInfo();


    this.compilation.showPackingSummaryInPdf = this.compilation.packingConditions.length > 1;

    // console.log('packing info (boxes)', this.compilation.packingConditions);

    // console.timeEnd('recalc packing...');
    this.cdRef.detectChanges();

  }


  // recalc() {
  //   this.cdRef.reattach();
  //   console.log('recalc packing...');
  //   const palletDetails = this.packingStore.find(f => f.id === 'palletDetails')?.data;
  //   const boxDetails = this.packingStore.find(f => f.id === 'boxDetails')?.data;
  //   // const boxLayer = this.packingStore.find(f => f.id === 'boxLayer')?.data;
  //   // const multiplier = this.packingStore.find(f => f.id === 'multiplier')?.data;
  //   const finalPacking = this.packingStore.find(f => f.id === 'finalPacking')?.data;

  //   console.log(this.packingStore, palletDetails, boxDetails, finalPacking);

  //   this.compilation.packingConditions.forEach(pallet => {

  //     // calc collie dimensions
  //     const palletRow = palletDetails?.find(f => f.id === pallet.palletType);
  //     const cartonBox = pallet.items[0]?.typeOfBox;
  //     const cartonRow = boxDetails.find(f => f.id === cartonBox);
  //     // const layerRow = boxLayer.find(f => f.pallet === palletRow?.name && f?.cartonBox === cartonBox);
  //     const finalPackingRow = finalPacking.find(f => f.pallet === palletRow?.id && f?.cartonBox === cartonBox);

  //     console.log('calc collie dimensions', pallet.palId, palletRow, cartonBox, cartonRow, finalPackingRow)

  //     const numberOfBoxes = +pallet.items.reduce((a, c) => a + c.numberOfBoxes, 0);
  //     const boxesPerLayer = +finalPackingRow.boxesPerLayer// +layerRow?.boxesPerLayer;
  //     const boxHeight = +cartonRow?.height;
  //     const multiplier = (+finalPackingRow.multiplier + 100) / 100;

  //     const calcHeight = +palletRow?.height + Math.ceil(numberOfBoxes / boxesPerLayer) *  boxHeight;
  //     pallet.dimensions = `${palletRow?.length}x${palletRow?.width}x${calcHeight}`;

  //     console.log('calc(2)', numberOfBoxes, boxesPerLayer, boxHeight, multiplier, calcHeight, pallet.dimensions);

  //     // calc net / gross weight
  //     const netWeight = pallet?.items?.reduce((a, c) => {
  //       const boxes: SpoBoxModel[] = c.boxes?.map(m => this.spoBoxes[m]) //?.reduce((a, c) => a + c?.weight), 0);
  //       const weight = boxes.reduce((a, c) => a + c.weight, 0);
  //       console.log('boxes', boxes, weight);
  //       return a + weight;
  //     }, 0);
  //     pallet.netWeight = Math.round(netWeight);
  //     pallet.weight = Math.round(netWeight * multiplier  + numberOfBoxes*(+cartonRow?.weight) + (+palletRow?.weight));

  //     console.log(pallet.dimensions, netWeight, pallet.netWeight, pallet.weight);
  //   })

  //   this.compilation.lineItems[this.lineItemIdx]?.pfspo.forEach(spo =>
  //     console.log('=-=-=->box details', spo.docLineItem?.boxDetails)
  //   ) 

  // }

  // rebuildPacking(lineItem: LineItemModel) {
  //   const data = this.packingWizardData;
  //   console.log('rebuild packing', data);
    
  //   this.cdRef.detach();

  //   const pallets = []
  //   Object.keys(data.finalPacking).forEach(async cb => {

  //     const packingConfig = data.finalPacking[cb];
  //     const boxes = data.boxes.filter(f => f.boxType === cb);

  //     console.log('boxes', boxes, data.boxes, cb);

  //     const palletBoxCount = packingConfig.boxesPerLayer * packingConfig.layersPerPallet;

  //     while (boxes.length) {
  //       const items = boxes.splice(0, palletBoxCount);

  //       // const newPallet = new PackingConditions();
  //       // newPallet.items = [];
  //       // newPallet.palettType = packingConfig.pallet;
  //       // newPallet.lineItemIdx = this.compilation.lineItems.findIndex(f => f.position.internalPos === lineItem.position.internalPos);
  //       // newPallet.dimensions = this.data.getPackingConfig(packingConfig.cartonBox)?.name;

  //       const newPallet = await this.addPallet(this.compilation.lineItems.findIndex(f => f.position.internalPos === lineItem.position.internalPos))

  //       console.log('rebuildPacking', cb, data.finalPacking[cb], packingConfig.pallet, this.data.getPackingConfig(packingConfig.pallet))

  //       // line per spo
  //       const spos = Array.from(new Set(items.map(m => m.spo)));

  //       const section = [];
  //       spos.forEach(spo => {
  //         const spoBoxes = items.filter(f => f.spo === spo);

  //         console.log('spo boxes', spoBoxes);

  //         let line = [];
  //         let ct = 0;
  //         let current, next;
  //         do {
  //           current = spoBoxes[ct];
  //           next = spoBoxes[++ct];
  //           if (next && +next.case === +current?.case + data.sortOrder) {
  //             line.push(current);
  //           } else {
  //             line.push(current);
  //             if (current) section.push(line);
  //             line = [];
  //           }
  //         } while (current);
          
  //       })


  //       section.forEach((el: SpoBoxModel[]) => {
  //         // const item = new PackingConditionItem();
  //         // item.boxes = el.flat().map(m => nrkPad(m.boxId, 3));
  //         const cs = el?.reduce((a, c) => [...a, c.case], []).map(m => nrkPad(m, 3));
  //         let tc = el?.reduce((a, c) => [...a, ...((c as any)?.tc || [])], []);
  //         const weight = el?.reduce((a, c) => a + c.weight, 0);
  //         const newItem = new PackingConditionItem();
  //         newItem.csNr = this.numericCombine(cs, 3);
  //         newItem.numberOfBoxes = el?.length;
  //         newItem.tcNr = this.numericCombine(tc);
  //         newItem.quantity = el?.reduce((a, c) => a + (+c.quantity), 0);
  //         newItem.boxes = el.map(m => m.boxId);
  //         newItem.typeOfBox = el[0].boxType;
  //         newPallet.items.push(newItem);
  //       })

  //       // pallets.push(newPallet);

  //     }
  //   })


  //   console.log('^^^^^^^^^^^^^', pallets);

  //   // pallets.forEach(async p => {
  //   //   const pallet = await this.addPallet(0);
  //   //   pallet.palettType = p.type;
  //   //   pallet.dimensions = p.dimensions;
  //   //   p.items.forEach(i => {
  //   //     const item = this.addItem(pallet);
  //   //     item.boxes = i.boxes;
  //   //     item.csNr = i.csNr;
  //   //     item.numberOfBoxes = i.numberOfBoxes;
  //   //     item.tcNr = i.tcNr;
  //   //     item.typeOfBox = i.typeOfBox;
  //   //     item.quantity = i.quantity;
  //   //   })
  //   // })

  //   // console.log('assigning packing')
  //   // this.cdRef.detach();
  //   // this.compilation.packingConditions = pallets;
  //   // window.setTimeout(() => this.cdRef.reattach());
  //   // console.log('packing assigned')
  //   // // this.packingChanged.emit(pallets);

  // }

  numericCombine(list: any[], pad: number = 0) { // AAA1, AAA7, AAA8, ABC001, ABC002, ABC003, ABC007 -> AAA1; AAA7-AAA8; ABC0001-ABC0003; ABC007

    const res = {};
    list?.forEach(li => {
      const [_, alpha, num] = li?.match(/([A-Za-z]*)(\d+)/) || ['','','']
      if (!res[alpha]) res[alpha] = [];
      res[alpha].push(+num);
      res[alpha] = res[alpha].sort((a, b) => +a > +b ? 1 : -1);
    })

    // console.log('num combine1', res);

    let row = '';
    Object.keys(res).forEach((el, idx) => {
      let current = res[el].shift();
      let previous = current;
      let next = res[el].shift();
      do {
        row += el + (pad ? current.toString().padStart(pad, '0') : current);
        let dash = false;
        while (next === current || next === current + 1) {
          dash = true;
          previous = current;
          current = next;
          next = res[el].shift();
        }
        if (dash && current !== previous) {
          // console.log('current, prev, next', current,previous,next);
          row += '-' + el + (pad ? current.toString().padStart(pad, '0') : current);
        }
        previous = current;
        current = next;
        next = res[el].shift();
        row += '; '; 
      } while (current);
    })

    return row;
  }

  async assignLots(pallet: PackingConditions) {

    const selected = this.productionLotTable.filter(f => f.selected);

    selected.forEach(row => {
      row.pallet = pallet;
    })

    const spos = {}
    selected.forEach(s => {
      if (!spos[s.spo]) spos[s.spo] = [];
      spos[s.spo].push(s);
    })

    let ct = 0;
    const boxgroup = [];
    Object.keys(spos).forEach(spo => {
      let first = +spos[spo][0].case;
      spos[spo].forEach((box: SpoBoxModel, idx)=> {
        const len = spos[spo].length;
        const current = +box.case;
        const next = idx < len - 1 ? +spos[spo][idx+1]?.case : 0;
        if (!boxgroup[ct]) boxgroup[ct] = [];
        if (next === current + 1) {
          boxgroup[ct].push(box);
        } else {
          boxgroup[ct++].push(box);
          first = next;
        }
      })
    })

    boxgroup.forEach(boxes => {
      const cs = boxes?.reduce((a, c) => [...a, c.case], []).map(m => nrkPad(m, 3));
      // let tc = boxes?.reduce((a, c) => [...a, ...(c?.tc || [])], []);
      // console.log('boxes', boxes);
      let tc = boxes?.map(m => m?.tc).flat();
      const weight = boxes?.reduce((a, c) => a + c.weight, 0);
      const newItem = this.addItem(pallet);
      newItem.csNr = this.numericCombine(cs, 3);
      newItem.numberOfBoxes = boxes?.length;
      newItem.tcNr = this.numericCombine(tc);
      newItem.quantity = boxes?.reduce((a, c) => a + (+c.quantity), 0);
      newItem.boxes = boxes.map(m => m.boxId);
      newItem.typeOfBox = boxes[0].boxType;
    })

    // console.log(boxgroup);

      // const cs = selected?.reduce((a, c) => [...a, c.case], []).map(m => nrkPad(m, 3));
      // let tc = selected?.reduce((a, c) => [...a, ...(c?.tc || [])], []);
      // const weight = selected?.reduce((a, c) => a + c.weight, 0);
      // item.csNr = this.numericCombine(cs, 3);
      // item.numberOfBoxes = selected?.length;
      // item.tcNr = this.numericCombine(tc);
      // item.quantity = selected?.reduce((a, c) => a + (+c.quantity), 0);
      // pallet.netWeight = pallet.netWeight ? +pallet.netWeight + weight : weight;

    this.setBoxStatus(boxgroup.flat().map(m => m.boxId), EBoxStatus.assignedPallet);

    // item.boxes = selected.map(box => box.boxId);
    // console.log('items', item.boxes, free);
    // this.setBoxStatus(item.boxes, free ? EBoxStatus.assignedSpo : EBoxStatus.assignedPallet);
  }

  generatePalletItems(data: IPackingWizardData, cartonBox: string, pallet: PackingConditions, boxes: SpoBoxModel[]) {

    // console.log('generate pallet items', data, cartonBox, pallet, boxes);

    let line = [];
    let ct = 0;
    let current, next;
    do {
      current = boxes[ct];
      // console.log('bosxes', ct, current);
      next = boxes[++ct];
      if (next && +next.case === +current?.case + data.sortOrder) {
        line.push(current);
      } else {
        line.push(current);
        if (current) {

          const cs = line?.reduce((a, c) => [...a, c.case], []).map(m => nrkPad(m, 3));
          let tc = Array.from(new Set(line?.reduce((a, c) => [...a, ...((c as any)?.tc || [])], []))).sort();

          // console.log('line, tc', line, tc);

          const item = new PackingConditionItem();
          item.numberOfBoxes = line.length;
          item.csNr = this.numericCombine(cs, 3);
          item.tcNr = this.numericCombine(tc);
          item.quantity = line?.reduce((a, c) => a + (+c.quantity), 0);
          item.netWeight = line?.reduce((a, c) => a + (+c.weight), 0);
          item.typeOfBox = cartonBox;
          item.boxes = line.map(m => m.boxId);

          // console.log('===>crae', item.boxes);
          // console.log('packing conditions item', tc, item.tcNr, item);
          // console.log('generatePalletItems', item.netWeight);
      
          pallet.items.push(item);
          // this.packingTypeOptions = this.getPackingTypeOptions(pallet, item.typeOfBox);

        }
        line = [];
      }
    } while (current);

    this.recalc();
  }


  async generatePallets(data: IPackingWizardData, lineItem: LineItemModel) {

    // console.log('generate pallets', data, lineItem, data.boxes.length, Object.keys(data.finalPacking), this.productionLotTable);

    const lineItemIdx = this.compilation.lineItems.findIndex(f => f.position.internalPos === lineItem.position.internalPos);

    const pallets = [];

    for (const cb of Object.keys(data.finalPacking)) {

      const packingConfig = data.finalPacking[cb];
      const boxes = data.boxes.filter(f => f.boxType === cb);
      const palletBoxCount = packingConfig.boxesPerLayer * packingConfig.layersPerPallet;
      if (palletBoxCount <= 0) continue;

      // console.log('generate pallets1b', packingConfig, boxes, data.boxes.map(m => m.boxType));
      while (boxes.length) {

        const boxChunk = boxes.splice(0, palletBoxCount);

        const pallet = new PackingConditions();
        pallet.palId = await this.generateNewPalletId()
        pallet.lineItemIdx = lineItemIdx;
        pallet.items = [];
        pallet.packingType = packingConfig.id;
        pallet.palletType = this.data.getPackingConfig(pallet.packingType)?.pallet;

        const spos = Array.from(new Set(boxChunk.map(m => m.spo)));

        // console.log('generate pallets1c', pallet.palId, boxChunk, spos, cb, data.boxes.map(m => m.boxType));
        
        for (const spo of spos) {

          const spoBoxes = boxChunk.filter(f => f.spo === spo);

          spoBoxes.forEach(box => box.palletRef = pallet.palId);
          // console.log('generate pallets2', spoBoxes);
          this.api.saveSpoBoxes(spoBoxes);

          this.generatePalletItems(data, packingConfig.cartonBox, pallet, spoBoxes);

        }

        pallets.push(pallet)

        // console.log('generate pallets3',pallets)
    
      }
    }

    lineItem.packingType = pallets[0]?.packingType;

    this.compilation.packingConditions = [...this.compilation.packingConditions.filter(f => f.lineItemIdx !== lineItemIdx), ...pallets];

  }

  movePallet(pallet: PackingConditions, up: boolean) {
    if (this.canMovePallet(pallet, up)) {
      const pallets = this.compilation.packingConditions.sort((a, b) => a.lineItemIdx === b.lineItemIdx ? 0 : ( a.lineItemIdx > b.lineItemIdx ? 1 : -1 ));
      const idx = pallets.findIndex(f => f === pallet);
      const cut = pallets.splice(idx, 1);
      pallets.splice(idx + (up ? -1 : 1), 0, cut[0]);
      console.log('move pallet', idx, pallet, cut[0], pallets)
      this.compilation.packingConditions = pallets;
    }
  }

  canMovePallet(pallet: PackingConditions, up: boolean) {
    const pallets = this.compilation.packingConditions.sort((a, b) => a.lineItemIdx === b.lineItemIdx ? 0 : ( a.lineItemIdx > b.lineItemIdx ? 1 : -1 ));
    const idx = pallets.findIndex(f => f === pallet);
    return pallets[idx].lineItemIdx === pallets[idx+(up ? -1 : 1)]?.lineItemIdx
  }
  // packingWizardData: IPackingWizardData;
  async savePackingWizardData(data: IPackingWizardData, lineItem: LineItemModel) {
    await this.generatePallets(data, lineItem);
    this.recalc()
    await this.saveCompilation();
  }

  async saveWarehousingPalletData(data: IPackingWizardData) {
    await this.savePalletData(data, this.ocCompilation);
    this.compilation.packingConditions = this.ocCompilation.packingConditions
    this.cdRef.detectChanges();
    await this.initProductionTable();
    this.recalc();
    console.log('warehousing data', data);
    PopupDocumentComponent.addWarehousingLog(this.compilation, this.data, this.api, this.auth, 'Packing Changed', `Pallet ${data.pallet.palId}`);
  }

  async savePalletData(data: IPackingWizardData, compilation = this.compilation) {
    const typeOfBox = data.pallet.items[0]?.typeOfBox;
    data.pallet.items = [];
    this.generatePalletItems(data, typeOfBox, data.pallet, data.boxes)
    await this.saveCompilation(null, compilation);
  }

  async saveCompilation(spoBoxes = null, compilation = this.compilation) {
    if (spoBoxes) await this.api.saveSpoBoxes(spoBoxes);
    const doc = await this.api.loadCompilation(mongoId(compilation));
    doc.packingConditions = compilation.packingConditions;
    await this.api.saveCompilation(doc);
    await this.tree.synchronizeSharedFields(compilation);
    await this.initProductionTable();
    this.recalc();
  }

  setTotalGrossWeight() {
    this.grossWeight = this.compilation.packingConditions && this.compilation.packingConditions.length &&
      this.compilation.packingConditions.reduce((sum, item) => sum + (1 * item.weight), 0);
    this.grossWeightChange.emit(this.grossWeight);
  }

  checkValid() {
    this.setTotalGrossWeight();
    return Array.isArray(this.compilation.packingConditions) 
  }

  getClipboardPackingHtml(lidx: number) {
    if (!this.getPackingFor(lidx)?.length) return '';
    let html = `
    <div>
      <div><b>Packing Information</b></div>
      <div>&nbsp;</div>
      <div><b>${this.compilation.code} Pos: ${lidx+1}</b></div>
      <table cellspacing="0" style="border-collapse:collapse;">
        <tr>
          <th style="background-color: lightgray;border:1px solid black;padding:5px">Pos</th>
          <th style="background-color: lightgray;border:1px solid black;padding:5px">Pallet ID</th>
          <th style="background-color: lightgray;border:1px solid black;padding:5px">Pallet Type</th>
          <th style="background-color: lightgray;border:1px solid black;padding:5px">Collie Dimensions</th>
          <th style="background-color: lightgray;border:1px solid black;padding:5px">CS#</th>
          <th style="background-color: lightgray;border:1px solid black;padding:5px">TC#</th>
          <th style="background-color: lightgray;border:1px solid black;padding:5px"># Boxes</th>
          <th style="background-color: lightgray;border:1px solid black;padding:5px"># Pieces</th>
          <th style="background-color: lightgray;border:1px solid black;padding:5px">Type of Carton Box</th>
          ${this.compilation.useOldPackingConditions ? '' : '<th style="background-color: lightgray;border:1px solid black;padding:5px">Net (kg)</th>'}
          <th style="background-color: lightgray;border:1px solid black;padding:5px">Gross (kg)</th>
        </tr>`

        this.getPackingFor(lidx).forEach(pallet => {
          pallet.items.forEach((row, idx) => {
            html += `
            <tr style="border: 1px solid black">`
              html += idx === 0 ? `<td rowspan="${pallet.items.length}" style="border:1px solid black;text-align:center;padding:5px">${this.getPos(pallet)}/${this.compilation.packingConditions.length}</td>` : '';
              html += idx === 0 ? `<td rowspan="${pallet.items.length}" style="border:1px solid black;text-align:center;padding:5px">${pallet.palId}</td>` : ''
              html += idx === 0 ? `<td rowspan="${pallet.items.length}" style="border:1px solid black;text-align:center;padding:5px">${pallet.palletType === 'P0' ? 'no pallet' : this.data.getOptionName(this.data.palletTypeOptions, pallet.palletType)}</td>` : ''
              html += idx === 0 ? `<td rowspan="${pallet.items.length}" style="border:1px solid black;text-align:center;padding:5px">${pallet.dimensions}</td>` : ''
              html += `<td style="border:1px solid black;text-align:center;padding:5px">${row.csNr}</td>
              <td style="border:1px solid black;text-align:center;padding:5px">${row.tcNr}</td>
              <td style="border:1px solid black;text-align:right;padding:5px">${row.numberOfBoxes}</td>
              <td style="border:1px solid black;text-align:right;padding:5px">${row.quantity}</td>
              <td style="border:1px solid black;text-align:center;padding:5px">${this.data.getOptionName(this.data.cartonBoxOptions, row.typeOfBox)}</td>
              ${this.compilation.useOldPackingConditions ? '' : '<td style="border:1px solid black;text-align:right;padding:5px">'+Math.round(row.netWeight)+'</td>'}`
              html += idx === 0 ? `<td rowspan="${pallet.items.length}" style="border:1px solid black;text-align:right;padding:5px">${Math.round(pallet.weightOverride || pallet.weight)}</td>` : ''
            html += `</tr>`
          })
        });
    
        html += `
        <tr>
          <td colspan="11" style="border:1px solid black;text-align:center;padding:8px">
            <div>
              <span>
                <b>Σ Boxes: ${this.getTotalSumBoxes(lidx)}</b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              </span>
              <span style="padding-left:3rem">
                <b>Σ pieces: ${this.getTotalSumPieces(lidx)}</b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              </span>`
        html += this.compilation.useOldPackingConditions ? '' : `<span>
                <b>Total Net Weight: ${Math.round(this.netWeightPerPos[lidx])} kg</b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              </span>`
        html +=    `<span>
                <b>Total Gross Weight: ${Math.round(this.grossWeightPerPos[lidx])} kg</b>
              </span>
            </div>
          </td>
        </tr>
      </table>
    </div>`

    return html;
  }

  getClipboardSummaryHtml(lidx: number) {
    this.palletSummary = this.getPalletSummary();
    let html = `
    <div>
      <div>Pallet Summary</div>
      <table cellspacing="0" style="border-collapse:collapse;">
        <tr>
          <th style="background-color: lightgray;border:1px solid black;padding:5px">Pallet ID</th>
          <th style="background-color: lightgray;border:1px solid black;padding:5px">Pallet Type</th>
          <th style="background-color: lightgray;border:1px solid black;padding:5px">Collie Dimensions</th>
          <th style="background-color: lightgray;border:1px solid black;padding:5px">DN & Pos</th>
          <th style="background-color: lightgray;border:1px solid black;padding:5px">Total # of Boxes</th>
          ${this.compilation.useOldPackingConditions ? '' : '<th style="background-color: lightgray;border:1px solid black;padding:5px">Net Weight (kg)</th>'}
          <th style="background-color: lightgray;border:1px solid black;padding:5px">Gross Weight (kg)</th>
        </tr>`

        this.palletSummary.forEach(row => {
          row.items.forEach((item, idx) => {
            html += `
            <tr style="border: 1px solid black">`
              html += idx === 0 ? `<td rowspan="${row.items.length}" style="border:1px solid black;text-align:center;padding:5px">${row.id}</td>` : ''
              html += idx === 0 ? `<td rowspan="${row.items.length}" style="border:1px solid black;text-align:center;padding:5px">${row.palletType}</td>` : ''
              html += idx === 0 ? `<td rowspan="${row.items.length}" style="border:1px solid black;text-align:center;padding:5px">${row.collieDimensions}</td>` : ''
              html += `<td style="border:1px solid black;text-align:center;padding:5px">${item.code} Pos: ${item.pos}</td>
              <td style="border:1px solid black;text-align:center;padding:5px">${item.numBoxes}</td>`
              html += this.compilation.useOldPackingConditions ? '' : `<td style="border:1px solid black;text-align:center;padding:5px">${Math.round(item.netWeight)}</td>`
              html += idx === 0 ? `<td rowspan="${row.items.length}" style="border:1px solid black;text-align:center;padding:5px">${Math.round(row.grossWeight)}</td>` : ''
              html += `</tr>`
          });
        });
    
        html += `
        <tr>
          <td colspan="7" style="border:1px solid black;text-align:center;padding:8px">
            <div>
              <span>
                <b>Σ Boxes: ${this.getTotalSumBoxes()}</b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              </span>
              <span style="padding-left:3rem">
                <b>Σ pieces: ${this.getTotalSumPieces()}</b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              </span>`
        html += this.compilation.useOldPackingConditions ? '' : `<span>
                <b>Total Net Weight: ${Math.round(this.totalNetWeight)} kg</b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              </span>`
        html += `<span>
                <b>Total Gross Weight: ${Math.round(this.totalGrossWeight)} kg</b>
              </span>
            </div>
          </td>
        </tr>
      </table>
    </div>`

    return html;
  }

  copyToClipboard() {
    // this.print = true;
    // this.cdRef.detectChanges();
    // const subscr = this.ngZone.onStable.subscribe(() => {
    //   const html = `<html><head><style>
    //       table { border-collapse:collapse } 
    //       th { background-color: #ddd } 
    //       td, th { border:1px solid black;padding: 0.5em 1em !important}
    //     </style></head><body>
    //       <div style="margin: 0 0 5pt 5pt"><b>Packing details</b></div>
    //       ${this.packingTable.nativeElement.innerHTML}
    //     </body></html>`
    //   this.data.copyHtmlToClipboard(html)
    //   this.print = false;
    //   this.cdRef.detectChanges();
    //   subscr.unsubscribe();
    // })

    let html = '';
    this.compilation.lineItems.forEach((li, lidx) => {
      html += this.getClipboardPackingHtml(lidx);
      html += '<br><br>'
    })
    html += this.getClipboardSummaryHtml(0);

    // console.log('html', html)

    this.data.copyHtmlToClipboard(html);

  }

  getSumBoxes(pallet: PackingConditions, pos: number = undefined) {
    return pallet.items?.filter(f => pos === undefined || pos === pallet.lineItemIdx)?.reduce((a, c) => a + (+c.numberOfBoxes), 0)
  }

  isSumBoxesInvalid(pallet: PackingConditions, pos: number) {
    const sum = this.getSumBoxes(pallet, pos);
    const packing = this.data.getPackingConfig()?.finalPacking?.find(f => f.id === pallet.packingType);
    if (!packing) return true;
    return sum > (packing.boxesPerLayer * packing.layersPerPallet);
  }

  getSumPieces(pallet: PackingConditions, pos: number = undefined) {
    return pallet.items?.filter(f => pos === undefined || pos === pallet.lineItemIdx)?.reduce((a, c) => a + (+c.quantity), 0)
  }

  getSumUnit(pallet: PackingConditions) {
    return pallet.items?.reduce((a, c) => a + (+c['unitQuantity']), 0) + ' ' + UnitData.get(this.compilation.lineItems[pallet.lineItemIdx].displayUnit).short;
  }

  getTotalSumBoxes = (pos: number = undefined) => this.compilation.packingConditions.reduce((a, c) => a + this.getSumBoxes(c, pos), 0);

  getTotalSumPieces = (pos: number = undefined) => this.compilation.packingConditions.reduce((a, c) => a + this.getSumPieces(c, pos), 0);

  getSumBoxesQuantity(boxes: any) {
    if (typeof boxes?.filter !== 'function') {
      // TODO: boxes = {}
      console.error('getSumBoxesQuantity error', boxes);
      return;
    }
    return {
      boxes: boxes?.filter(f => f.selected).length,
      quantity: boxes?.filter(f => f.selected).reduce((a, c) => a + (+c.quantity), 0)
    }
  }

  // check if there is a box with shelf life < 6 months
  checkShelfLife(pallet: PackingConditions, lineItem = -1) {

    const boxes = this.spoBoxes.filter(f => f.palletRef === pallet?.palId);
    const boxDetails =  lineItem >= 0 ? this.compilation.lineItems[lineItem]?.boxDetails : null;

    // if (lineItem >= 0) console.log('check shelf life', lineItem, boxes, boxDetails);

    if (!boxes?.length && !boxDetails?.length) return false;
    
    const fp = this.compilation.lineItems[lineItem >= 0 ? lineItem : pallet?.lineItemIdx].finishedProduct;
    const product = fp?.product;
    // const shelfLife = product.shelfLife5Deg || product.shelfLife10Deg || product.shelfLife20Deg;

    const standard = fp.boxLabelPriority === EBoxLabelPriority.Standard5Deg || fp.boxLabelPriority === EBoxLabelPriority.Standard10Deg || fp.boxLabelPriority === EBoxLabelPriority.Standard20Deg;
    const column = fp.boxLabelPriority === EBoxLabelPriority.ExpiryColumn5Deg || fp.boxLabelPriority === EBoxLabelPriority.ExpiryColumn10Deg || fp.boxLabelPriority === EBoxLabelPriority.ExpiryColumn20Deg;
    const calc = fp.boxLabelPriority === EBoxLabelPriority.ExpiryCalculation5Deg || fp.boxLabelPriority === EBoxLabelPriority.ExpiryCalculation10Deg || fp.boxLabelPriority === EBoxLabelPriority.ExpiryCalculation20Deg;
    const deg5 = fp.boxLabelPriority === EBoxLabelPriority.Standard5Deg || fp.boxLabelPriority === EBoxLabelPriority.ExpiryColumn5Deg || fp.boxLabelPriority === EBoxLabelPriority.ExpiryCalculation5Deg;
    const deg10 = fp.boxLabelPriority === EBoxLabelPriority.Standard10Deg || fp.boxLabelPriority === EBoxLabelPriority.ExpiryColumn10Deg || fp.boxLabelPriority === EBoxLabelPriority.ExpiryCalculation10Deg;
    const deg20 = fp.boxLabelPriority === EBoxLabelPriority.Standard20Deg || fp.boxLabelPriority === EBoxLabelPriority.ExpiryColumn20Deg || fp.boxLabelPriority === EBoxLabelPriority.ExpiryCalculation20Deg;

    // console.log(doc.code, boxes.length, shelfLife);
    const shelfLife = deg5
    ? product.shelfLife5Deg 
    : deg10
      ? product.shelfLife10Deg
      : deg20
        ? product.shelfLife20Deg
        : product.shelfLife5Deg || product.shelfLife10Deg || product.shelfLife20Deg;

    // if (lineItem >= 0) console.log('--> shelf life', this.compilation.code, shelfLife, product.shelfLife5Deg || product.shelfLife10Deg || product.shelfLife20Deg);

    let dates = (boxes || boxDetails).map(box => {
      if (box.shelfLifeDate && column) return moment(box.shelfLifeDate);
      const minProdDate = moment.min(box.prodDate?.filter(notNull => notNull).map(m => moment(m)));
      if (!minProdDate || !minProdDate.isValid()) return null;
      return minProdDate.add(shelfLife, 'months');
    }).filter(notNull => notNull);

    const minShelfLifeDate = moment.min(dates);
    if (!minShelfLifeDate.isValid()) return false;
    const months = minShelfLifeDate?.diff(moment(this.compilation.vieDispatchDate), 'months', true);
    return shelfLife !== undefined && shelfLife !== null ? months < 6 : false;
  }

  lastSelectedIndex: number;
  onCheckboxChange(idx, event) {
    const shiftKey = event.shiftKey;
    if (shiftKey && typeof this.lastSelectedIndex !== 'undefined') {
      const startIndex = Math.min(this.lastSelectedIndex, idx);
      const endIndex = Math.max(this.lastSelectedIndex, idx);
      for (let i = startIndex; i <= endIndex; i++) {
        this.productionLotTable[i].selected = true;
      }
    }
    // console.log('on checkbox change', idx, this.productionLotTable.find(f => f.idx === idx), this.productionLotTable);
    this.lastSelectedIndex = idx;
  }

  // selectAllLots(selected) {
  //   this.productionLotTable.forEach(lot => {
  //     lot.selected = selected;
  //   })
  // }

  getPalData(pallet: PackingConditions) {
    return this.palletReferences?.find(f => f.palId === pallet.palId);
  }

  getPalRef(pallet: PackingConditions) {
    return this.palletReferences?.find(f => f.palId === pallet.palRef);
  }

  async palletRefChanged(idx: number, palletRef: string) {
    this.compilation.packingConditions.filter(f => f.lineItemIdx === idx).forEach((pal: PackingConditions) => {
      // console.log ('palletRefChanged', idx, palletRef)
      pal.palRef = palletRef;
    })
    await this.saveCompilation();
    this.recalc();
  }

  private getPalletInfo(): { [palletId: string]: any }  {

    // if (this.compilation.useOldPackingConditions) return;
    // console.time('get pallet info')

    const info = {} as any;

    this.netWeightPerPos = Array.from({length: 100}, () => 0);
    this.grossWeightPerPos = Array.from({length: 100}, () => 0);

    this.compilation.packingConditions.forEach(pal => {

      // console.log('pallet--:', pal.palId, pal);
      if (!info[pal.palId]) info[pal.palId] = {};

      info[pal.palId].pal = pal;
      info[pal.palId].palPos = `Pal ${this.getPos(pal)}/${this.compilation.packingConditions.length}`;
      info[pal.palId].id = pal.palId;
      info[pal.palId].palletType = pal.palletType === 'P0' ? 'no pallet' : this.data.getOptionName(this.data.palletTypeOptions, pal.palletType);
      info[pal.palId].dimensions = pal.dimensions;
      info[pal.palId].dn = `${this.tree?.linkedDN?.code|| this.compilation.code} Pos ${pal.lineItemIdx+1}`;
      info[pal.palId].boxes = this.getSumBoxes(pal);
      info[pal.palId].netWeight = Math.round(pal.items?.reduce((a, c) => a + (+c.netWeight || 0), 0));
      info[pal.palId].grossWeight = Math.round(pal.weightOverride || pal.weight || 0);
      info[pal.palId].items = [];

      console.log('====>pal compilation box weight', pal.palId, pal.weightOverride, pal.weight, this.compilation, pal);

      pal.items?.forEach(row => {

        // console.log('pal items', row)

        info[pal.palId].items.push({
          row: row,
          cs: row.csNr,
          tc: row.tcNr,
          boxes: row.numberOfBoxes,
          quantity: row.quantity,
          unitQuantity: this.getUnitQuantity(pal.lineItemIdx, row) || 0,
          typeOfBox: this.data.getOptionName(this.data.cartonBoxOptions, row.typeOfBox),
          netWeight: row.netWeight.toFixed(1),
        })

      })

      this.netWeightPerPos[pal.lineItemIdx] += pal.items.reduce((a, c) => a + c.netWeight, 0);
      // console.log('net weight per pos', this.netWeightPerPos, pal.items.reduce((a, c) => a + c.netWeight, 0));
      this.grossWeightPerPos[pal.lineItemIdx] += pal.weightOverride || pal.weight;
    })

    this.totalNetWeight = Object.values(info).reduce((a: number, c: any) => a + (+c?.netWeight || 0), 0) as number;
    this.totalGrossWeight = Object.values(info).reduce((a: number, c: any) => a + (+c?.grossWeight || 0), 0) as number;

    // console.timeEnd('get pallet info')

    return info;
  }

  getPalletSummary() {
    const rows = [];
    this.totalNetWeight = 0;
    this.totalGrossWeight = 0;
    this.compilation.packingConditions.forEach(pal => {
      const row = {} as any;
      row.id = pal.palRef ? pal.palRef : pal.palId;
      const pallet = this.data.getPackingConfig(pal.packingType)?.pallet;
      row.palletType = this.data.getPackingConfig(pal.palletType)?.name;
      row.collieDimensions = pal.dimensions;
      row.grossWeight = pal.weightOverride || pal.weight;
      row.grossWeightOverride = pal.weightOverride;
      row.calcGrossWeight = pal.weight;
      // console.log('summaryGross2', pal.palId, pal.weightOverride, pal.weight)
      row.items = [
        {
          code: this.compilation.code,
          pos: pal.lineItemIdx + 1,
          numBoxes: this.getSumBoxes(pal),
          netWeight: pal.netWeight,
          // grossWeight: 0
        }
      ]
      if (this.getPalRef(pal)) {
        row.items?.push({
          code: this.getPalRef(pal)?.code || '',
          pos: this.getPalRef(pal) ? this.getPalRef(pal).pos+1:'',
          numBoxes: this.getPalRef(pal).numBoxes,
          netWeight: this.getPalRef(pal).netWeight,
          // grossWeight: this.getPalRef(pal).weightOverride ? this.getPalRef(pal).weightOverride : this.getPalRef(pal).weight,
        })
        row.grossWeight += this.getPalRef(pal).weight;
      }
      this.totalNetWeight += row.items.reduce((a, c) => a + c.netWeight, 0);

      if (this.getPalRef(pal)?.weightOverride) row.grossWeightOverride = this.getPalRef(pal).weightOverride;

      // console.log('pal summaryGross3', pal.palId, row.grossWeight, row)

      if (!this.getPalData(pal)?.refPalId) {
        // console.log('totalGrossWeight', row.id, row.grossWeight, this.totalGrossWeight, row.grossWeight + this.totalGrossWeight)
        this.totalGrossWeight += row.grossWeight;
        rows.push(row);
      }
    })

    // console.log('getPalletSummary', rows);
    return rows.sort((a, b) => a.id > b.id ? 1 : -1);
  }

  summaryGrossWeightChanged(row, weight) {
    const pallet = this.compilation.packingConditions.find(p => p.palId === row.id);
    pallet.weightOverride = weight;
    this.saveCompilation().then(() => {
      this.tree.synchronizeSharedFields(this.compilation).then(() =>{
        // this.refreshPalletReferences();
      })
    });
  }

  // getMultiPalletColor(pallet: PackingConditions) {
  //   // const idx = this.compilation.packingConditions?.filter(f => f.palletType === 'P9')?.findIndex(p => p === pallet);
  //   // if (idx >= 0 && idx < 3) return this.multiPalletColors[idx];
  //   const idx = this.compilation.packingConditions?.filter(f => f.palRef)?.findIndex(p => p === pallet);
  //   if (idx >= 0 && idx < 3) return this.multiPalletColors[idx];
  // }

  getPackingTypeOptions(pallet: PackingConditions, boxType: string) {
    // const packingDataIds = this.data.compilationData.packingStore
    //   ?.find(f => f.id === 'finalPacking')?.data
    //   ?.filter(f => f.cartonBox === boxType)
    //   ?.map(m => m.id);
    
    const packingDataIds = this.data.getPackingConfig().finalPacking
      ?.filter(f => f.cartonBox === boxType)
      ?.map(m => m.id);
      // console.log('getPackingTypeOptions', packingDataIds, this.data.packingOptions.filter(f => packingDataIds.includes(f.id) ));
    return packingDataIds?.length 
      ? 
      this.data.packingOptions.filter(f => packingDataIds.includes(f.id) )
      :
      this.data.packingOptions;
  }

  // // legacy: set palletType by chosen packingType
  // packingTypeChanged(pallet: PackingConditions) {
  //   const packingData = this.data.compilationData.packingStore
  //     ?.find(f => f.id === 'finalPacking')?.data
  //     ?.find(f => f.id === pallet.packingType);
  //   pallet.palletType = packingData.pallet;

  //   console.log('packingTypeChanged', pallet, packingData);
  // }

  // async packingTypeChanged(lineItemIdx: number, packingType: string) {
  //   const packing = this.data.getPackingConfig(packingType);
  //   // this.getPackingFor(lineItemIdx).forEach(pallet => {
  //   //   pallet.packingType = packingType;
  //   //   pallet.palletType = packing.pallet;
  //   // })
  //   console.log('packingTypeChanged', this.compilation.packingConditions);
  //   // await this.saveCompilation();
  // }

  async packingTypeChanged(pallet: PackingConditions, packingType: string) {
    const packing = this.data.getPackingConfig(packingType);
    pallet.palletType = packing.pallet;
    // console.log('packingTypeChanged', this.compilation.packingConditions, packing, packingType, pallet);
    // await this.saveCompilation();
  }

  // boxTypeChange(pallet: PackingConditions, boxType: string) {
  //   this.packingTypeOptions = this.getPackingTypeOptions(pallet, boxType);
  // }

  showWizard(idx: number) {
    // console.log('showWizard', 
    //   this.isDisabled(),
    //   !this.disabled,
    //   !this.compilation.packingConditions.filter(f => f.lineItemIdx === idx)?.length,
    //   !this.disabled && !this.compilation.packingConditions.filter(f => f.lineItemIdx === idx)?.length
    // );
    return !this.disabled && !this.compilation.packingConditions.filter(f => f.lineItemIdx === idx)?.length
  }

  getPacking(pallet) {
    const fp = this.data.getPackingConfig()?.finalPacking;
    return this.data.getPackingConfig()?.finalPacking?.find(f => f.id === pallet.packingType);
  }

  // isRelabelling(lidx: number, pallet: PackingConditions) {
  //   console.log('recipient', mongoId(this.compilation.recipient), lidx, this.spoCustomerRefMismatch[lidx])
  //   // const recipientMismatch = item.pfspo?.find(f => f.doc?.recipient !== this.compilation?.recipient)
  //   const recipientMismatch = !this.spoCustomerRefMismatch[lidx].find(f => mongoId(f.recipient) !== mongoId(this.compilation.recipient))
  //   return recipientMismatch || pallet.relabelling || this.getPacking(pallet)?.relabelling;
  // }
  
  ocPallet(pidx: number) {
    return this.ocCompilation.packingConditions[pidx];
  }

  async onHeightOverride(pallet: PackingConditions, newHeight: number) {

    pallet.heightOverride = +newHeight;

    if (this.warehousing) {
      const doc = await this.api.loadCompilationByCode(this.compilation.code)
      doc.packingConditions = this.compilation.packingConditions;
      await Changelog.addAutolog(doc, this.auth.user, this.api, [{
        quickText: 'Change pallet height',
        text: `Pallet ${pallet.palId} to ${newHeight}cm (in Warehousing by ${this.auth.user.short})`,
      }]);
      PopupDocumentComponent.addWarehousingLog(doc, this.data, this.api, this.auth, `Change pallet height: Pallet ${pallet.palId} to ${newHeight}cm`);

      await this.api.saveCompilation(doc);
      console.log('save compilation', doc.code, doc);
    }
    this.recalc();
  }
}
